angular.module('backstage.directives.brandedApps', [])
    .directive('brandedAppAssetUploader', require('./brandedAppAssetUploader'))
    .directive('brandedAppScreenshotUploader', require('./brandedAppScreenshotUploader'))
    .directive('brandedAppActivationScreenEditor', require('./brandedAppActivationScreenEditor'))
    .directive('brandedAppI18nEditor', require('./brandedAppI18nEditor'))
    .directive('brandedAppBundleIdentifierEditor', require('./brandedAppBundleIdentifierEditor'))
    .directive('brandedAppEventListPreview', require('./brandedAppEventListPreview'))
    .directive('emailTemplateEditor', require('./emailTemplateEditor'))
    .directive('brandedAppSingleSignOnEditor', require('./brandedAppSingleSignOnEditor'));
